import script from "./Claim.vue?vue&type=script&setup=true&lang=js"
export * from "./Claim.vue?vue&type=script&setup=true&lang=js"

import "./Claim.vue?vue&type=style&index=0&id=05fa86f8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05fa86f8"]])

export default __exports__